import { Box, Typography, Button, Paper, Container, Fade } from '@mui/material';
import logo from '../../assets/images/oserLogo.svg';

/**
 * Pantalla de error para trámites SAT
 * Muestra mensaje de error y opción de reintentar
 * 
 * @param {Object} props
 * @param {string} props.title - Título de la pantalla de error
 * @param {string} props.subtitle - Subtítulo con instrucciones adicionales
 * @param {string} props.error - Mensaje de error a mostrar
 * @param {Function} props.onRetry - Función para reintentar (opcional)
 * @param {Boolean} props.onReload - Opción para mostrar el botón de recargar la página (opcional)
 * @param {React.ReactNode} props.children - Contenido secundario opcional
 */
const ErrorScreen = ({ title = 'Error en la carga', subtitle = 'Por favor, verifique su conexión y escanee el código QR nuevamente. Si el problema persiste, contacte a soporte técnico.', error = 'Ha ocurrido un error inesperado.', onRetry, onReload, children }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        overflow: 'auto'
      }}
    >
      <Container maxWidth="sm">
        <Fade in={true} timeout={800}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              borderRadius: 4,
              bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'hidden'
            }}
          >

            {/* Logo */}
            <Box sx={{ mb: 6, height: 100 }}>
              <img
                src={logo}
                alt="IOSPER Logo"
                style={{ height: '100%', objectFit: 'contain' }}
              />
            </Box>

            {/* Icono de Error */}
            {title && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
                {/* <Zoom in={true} timeout={1000}>
                  <ErrorOutlineIcon sx={{ fontSize: 50, color: 'error.main' }} />
                </Zoom> */}
                <Typography
                  variant="h4"
                  component="h1"
                  fontWeight="700"
                  sx={{ color: 'text.primary' }}
                >
                  {title}
                </Typography>
              </Box>
            )}

            {/* Mensaje de Error */}
            {error && (
              <Typography variant="body1" color="error" fontWeight="500" paragraph sx={{ mb: 4 }}
                textTransform={'uppercase'}>
                {error}
              </Typography>
            )}

            {/* Instrucciones adicionales */}
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }} fontSize={'1.125rem'}>
                {subtitle}
              </Typography>
            )}

            {/* Contenido Secundario */}
            {children}

            {/* Botón de Reintentar */}
            {onRetry && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={onRetry}
                sx={{ py: 1.5, px: 4, borderRadius: 2 }}
              >
                Reintentar
              </Button>
            )}

            {/* Opción de Recargar */}
            {onReload && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => window.location.reload()}
                sx={{ mt: 1 }}
              >
                Recargar página
              </Button>
            )}

          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default ErrorScreen;
